export default {
  history: {
    menuItem: "History",
    pageTitle: "System activity",
    pickDay: "Day",
    filterDateFrom: "From",
    filterDateTo: "To",
    filterDateRange: "Range",
    filterModel: "Model",
    filterModelPlaceholder: "All models",
    filterUser: "User",
    filterUserAll: "All users",
    filterAction: "Action",
    filterActionAll: "All",
    filterItem: "Item",
    filterItemPlaceholder: "Search by name…",
    filterItemClear: "Clear item",
    filterItemNeedModel: "Pick a model to search for an item.",
    groupContext: "Changes in item groups",
    datesRequireItem:
      "Without an item, From date is required. Empty dates are only allowed with an item filter.",
    dateRangeTooLarge: "Without an item, the range cannot exceed 31 days.",
    clearDatesHint: "Clear dates = full item history",
    clearDates: "Clear dates",
    unboundedBadge: "No date limit (item)",
    refresh: "Refresh",
    loading: "Loading…",
    empty: "No activity for this day.",
    emptyFiltered: "No activity for this action filter. Try “All”.",
    timeline: "Timeline",
    timelineTitle: "Item timeline",
    timelineClose: "Close",
    timelineEmpty: "No history for this item.",
    timelineError: "Could not load timeline.",
    timelinePoints: "events",
    timelinePointDetail: "What changed",
    timelineDeleted: "Deleted",
    timelineSoftDeleteHint: "Moved to trash.",
    tabList: "List",
    tabNetwork: "Network",
    graphHint: "Honeycomb nodes. Drag to reposition. Click = links. Wheel = zoom.",
    graphReset: "Reset",
    graphExpanding: "Loading links…",
    graphExpandError: "Could not load linked items.",
    summaryHistory: "Saves",
    summarySoftDelete: "Moved to trash",
    summaryHardDelete: "Hard deleted",
    summaryPrevDay: "Previous day saves",
    summaryDelta: "vs previous day",
    summaryMissing: "Saves for missing items",
    sectionSaves: "Creates & updates",
    sectionTrash: "Moved to trash (soft delete)",
    sectionHardDelete: "Hard deletes",
    hardDeleteOrphanHint: "Has history and the item no longer exists",
    hardDeleteEventHint: "Permanent delete recorded",
    viewItemHistory: "View history",
    actionCreate: "Created",
    actionUpdate: "Updated",
    actionSoftDelete: "Moved to trash",
    actionHardDelete: "Hard deleted",
    statusActive: "Active",
    statusTrash: "In trash",
    statusMissing: "Item missing (hard-deleted)",
    statusUnknown: "Unknown",
    by: "by",
    openItem: "Open",
    details: "Details",
    before: "Before",
    after: "After",
    noDiffs: "No field differences vs previous version.",
    notesTitle: "Notes",
    loadError: "Could not load activity.",
    entryError: "Could not load entry details.",
  },
};
